import { useCallback, useEffect, useRef, useState } from 'react';

export const useVirtualAccountPaginate = (id, pageNumber, setPageNumber, dataSource, values, transferType) => {
  const dataRef = useRef([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(null);
  const [currentList, setCurrentList] = useState([]);

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          if (data.length > 9) {
            setPageNumber((prev) => prev + 1);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, hasMore],
  );

  useEffect(() => {
    setPageNumber(1);
    setData([]);
    // eslint-disable-next-line react/display-name
    return () => null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, transferType, values]);

  const onChange = async () => {
    try {
      const data = await dataSource();
      setCurrentList(data);
      if (!data?.transactions) {
        if (pageNumber === 1) {
          setData(data?.customers);
        } else {
          setData((prevData) => {
            return [...prevData, ...data.customers];
          });
        }
        dataRef.current = data?.customers;
        setHasMore(data?.customers.length > 0);
      } else {
        if (pageNumber === 1) {
          setData(data?.customers);
        } else {
          setData((prevData) => {
            return [...prevData, ...data.customers];
          });
        }
        dataRef.current = data?.customers;
        setHasMore(data?.customers.length > 0);
      }
      setPageSize(data?.pages);
      setLoading(false);
    } catch (error) {
      setError(error.data?.data?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    onChange();
    // eslint-disable-next-line react/display-name
    return () => null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, id, values?.from, values?.to, transferType]);

  return { loading, error, data, hasMore, lastElementRef, observer, pageSize, onChange, currentList };
};
